import { ajax } from './ec-ajax';
import { openDialog } from './ec-popup';

const gnbTemplate = _.template('<li data-menu-id="<%= menuId %>"><a href="#none"><%= menuName %></a></li>');
const snbParentTemplate = _.template('<li data-menu-id="<%= menuId %>"><a href="#none"><%= menuName %></a><ul></ul></li>');
const snbChildTemplate = _.template('<li data-menu-id="<%= menuId %>"><a href="#" class="aside-menu-item"><%= menuName %></a></li>');

function logToMenuHistory(menuItem) {
    ajax({ url: `${GFN_CONTEXT_INFO['server.context']}/insSysStat.svc?menuId=${menuItem.menuId}&pgmId=${menuItem.pgmId}&ctxNm=${GFN_CONTEXT_INFO['server.context']}` });
}

function snbItemClickHandler(menuItem) {
    const e = $.Event('ec:snb-menu-click', menuItem);
    $('.nav-snb').trigger(e);

    logToMenuHistory(menuItem);
}

function generateSnb(menuItem) {
    const children = _.sortBy(menuItem.subMenu, 'order');
    const parent =
        $('.nav-snb').find('ul').find('li').length ?
            $('.nav-snb').find('ul').find(`li[data-menu-id="${menuItem.menuId}"] > ul`) :
            $('.nav-snb').find('ul');

    _.forEach(children, (child) => {
        if (_.has(child, 'subMenu') && _.isArray(child.subMenu)) {
            $(parent).append(snbParentTemplate(child));
            generateSnb(child);
        } else if (_.has(child, 'url')) {
            $(parent).append(snbChildTemplate(child));

            const menuElement = $(parent).find(`li[data-menu-id="${child.menuId}"]`);
            menuElement.click($.proxy(snbItemClickHandler, null, child));
        }
    });
}

function gnbItemClickHandler(menuItem, event) {
    $(event.currentTarget).closest('ul').find('li').removeClass('active');
    $(event.currentTarget).addClass('active');
    $('.nav-snb').find('ul').find('li').remove();

    if (_.has(menuItem, 'subMenu') && _.isArray(menuItem.subMenu)) {
        generateSnb(menuItem);
    }

    const e = $.Event('ec:gnb-menu-click', menuItem);
    $('.nav-gnb').trigger(e);
}

function generateGnb(data) {
    if (!_.isArray(data)) {
        throw new Error('Menu data must be type of Array.');
    }
    const menu = _.sortBy(data, 'order');

    _.forEach(menu, (menuItem) => {
        if (_.has(menuItem, 'subMenu') && _.isArray(menuItem.subMenu)) {
            $('.nav-gnb').find('ul').append(gnbTemplate(menuItem));

            const menuElement = $('.nav-gnb').find('ul').find(`li[data-menu-id="${menuItem.menuId}"]`);
            menuElement.click($.proxy(gnbItemClickHandler, null, menuItem));
        }
    });
}

function favItemClickHandler(menuItem) {
    const e = $.Event('ec:fav-menu-click', menuItem);
    $('.nav-fav').trigger(e);
}

function generateFavSub(menuItem, topNode) {
    const children = _.sortBy(menuItem.subMenu, 'order');
    const parent =
        $('.nav-fav').find('ul').find('li').length ?
            $('.nav-fav').find('ul').find(`li[data-menu-id="${topNode.menuId}"] > ul`) :
            $('.nav-fav').find('ul');

    _.forEach(children, (child) => {
        if (_.has(child, 'subMenu') && _.isArray(child.subMenu)) {
            generateFavSub(child, topNode);
        } else if (_.has(child, 'url')) {
            $(parent).append(snbChildTemplate(child));

            const menuElement = $(parent).find(`li[data-menu-id="${child.menuId}"]`);
            menuElement.click($.proxy(favItemClickHandler, null, child));
        }
    });
}

function generateFav(data) {
    if (!_.isArray(data)) {
        throw new Error('Menu data must be type of Array.');
    }
    $('.nav-fav').find('ul').find('li').remove();
    const menu = _.sortBy(data, 'order');

    _.forEach(menu, (menuItem) => {
        if (_.has(menuItem, 'subMenu') && _.isArray(menuItem.subMenu)) {
            $('.nav-fav > ul').append(snbParentTemplate(menuItem));
            generateFavSub(menuItem, menuItem);
        } else if (_.has(menuItem, 'url')) {
            $('.nav-fav > ul').append(snbChildTemplate(menuItem));
        }
    });
}

function getFrameContent(id) {
    return $(top.document).find(`#${id}`).find('iframe').contents();
}

function getFrameFunction(id) {
    if (_.isEmpty(id)) {
        openDialog('message', 'Target frame id is not defined.');
        return false;
    }
    return $(top.document).find(`#${id}`).find('iframe')[0].contentWindow;
}

export { generateGnb, generateSnb, generateFav, getFrameContent, getFrameFunction };



// WEBPACK FOOTER //
// ./src/utils/ec-ui.js